import createPropType from "./createResponsivePropType";

const alignPropType = createPropType(["left", "center", "right"]);

export default alignPropType;
